const BrowseLink = () => {
  return <div>ffgg</div>;
};

export { BrowseLink };
